/**
 * @name Home
 * @description Componente del dashboard home
 * @author César Rivera
 */

import React, { PureComponent } from 'react';
import i18n from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import styled from 'styled-components';

import { LoadingWrapper } from '@components';
import { EmployeeService, ResponseHandlerService } from '@services';
import { Card, Layout, MUI, Typography } from '@styles';

// Components
import Birthdays from './components/birthdays';
import Carousel from './components/carousel';
import EmployeesGraph from './components/employees-graph';
import News from './components/news';
import WorkAnniversaries from './components/work-anniversaries';

// Dialogs
import BirthdaysDialog from './dialogs/birthdays.dialog';
import WorkAnniversariesDialog from './dialogs/work-anniversaries.dialog';

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      companyId: '',
      companyName: '',
      companyLogo: '',
      // companyDescription: '',
      // companyRelease: '',
      companyImages: [],
      companyMission: '',
      companyVision: '',
      companyValues: [],
      companyGoals: [],
      birthdaysInfo: [],
      birthdaysDialog: false,
      workAnniversariesInfo: [],
      workAnniversariesDialog: false,
    };
  }

  componentDidMount() {
    this.getCompanyInfo();
  }

  getCompanyInfo = () => {
    trackPromise(
      EmployeeService.getInfo()
        .then((response) => {
          this.setState({
            companyId: response.Empresa.IdEmpresa,
            companyName: response.Empresa.Empresa,
            companyLogo: response.Empresa.Logo,
            // companyDescription: response.Empresa.Descripcion,
            // companyRelease: response.Empresa.Comunicado,
            companyImages: response.ImagenesCarrusel,
            companyMission: response.CulturaEmpresa.find((element) => element.Concepto === 'Mision') || '',
            companyVision: response.CulturaEmpresa.find((element) => element.Concepto === 'Vision') || '',
            companyValues: response.CulturaEmpresa.filter((element) => element.Concepto === 'Valor'),
            companyGoals: response.CulturaEmpresa.filter((element) => element.Concepto === 'Objetivo'),
            employeesMan: response.Empresa.Masculino,
            employeesWoman: response.Empresa.Femenino,
            birthdaysInfo: response.EmpleadoCumpleanios,
            workAnniversariesInfo: response.EmpleadoAniversario,
            showGraphEmployees: response.Empresa.GraficaVisible,
            showBirthdaysMonth: response.Empresa.CumpleaniosVisible,
            showAnniversariesMonth: response.Empresa.AniversariosVisible
          });
        }).catch((error) => {
          ResponseHandlerService.error(error);
        }),
      'loading-home'
    );
  }

  openDialog = (dialog) => {
    switch (dialog) {
      case 'birthdays':
        this.setState({ birthdaysDialog: true });
        break;
      case 'workAnniversaries':
        this.setState({ workAnniversariesDialog: true });
        break;
      default:
        break;
    }
  }

  closeDialog = (dialog) => {
    switch (dialog) {
      case 'birthdays':
        this.setState({ birthdaysDialog: false });
        break;
      case 'workAnniversaries':
        this.setState({ workAnniversariesDialog: false });
        break;
      default:
        break;
    }
  }

  render() {
    const {
      companyId,
      companyName,
      companyLogo,
      // companyDescription,
      // companyRelease,
      companyImages,
      companyMission,
      companyVision,
      companyValues,
      companyGoals,
      employeesMan,
      employeesWoman,
      birthdaysInfo,
      birthdaysDialog,
      workAnniversariesInfo,
      workAnniversariesDialog,
      showGraphEmployees,
      showBirthdaysMonth,
      showAnniversariesMonth
    } = this.state;

    return (
      <LoadingWrapper area={'loading-home'}>
        <Layout.Title>
          <Typography.H3>{i18n.t('GenericMessages.welcome')}</Typography.H3>
        </Layout.Title>

        <Layout.Content>
          <MUI.Grid container>
            {/* Logo Empresa */}
            {companyLogo && (
              <GridItem item md={2} sm={4} xs={12}>
                <Card.Paper height={200}>
                  <CompanyLogoImg url={companyLogo}></CompanyLogoImg>
                </Card.Paper>
              </GridItem>
            )}

            {/* Empresa (Misión) */}
            <GridItem item md={companyLogo ? 10 : 12} sm={companyLogo ? 8 : 12} xs={12}>
              <Card.Paper height={200}>
                <Card.Header>
                  <Card.HeaderTitle>
                    <Typography.H4>{companyName}</Typography.H4>
                  </Card.HeaderTitle>
                </Card.Header>
                <Card.Content>
                  {companyMission.length !== 0 && (
                    <>
                      {/* Validación KPMG */}
                      <Typography.H5 style={{ padding: '0 8px' }}>{companyId !== 93 ? i18n.t('Home.mission') : i18n.t('Home.purpose')}</Typography.H5>
                      <br />
                      <Typography.Text>{companyMission.Descripcion}</Typography.Text>
                    </>
                  )}
                </Card.Content>
              </Card.Paper>
            </GridItem>

            {/* Cultura Empresa (Visión y Valores) */}
            {(companyVision.length !== 0 || companyValues.length !== 0 || companyGoals.length !== 0) && (
              <MUI.Grid container item sm={6} xs={12}>
                {/* Visión */}
                <GridItem item sm={12} xs={12}>
                  <Card.Paper height={200}>
                    <Card.Header>
                      <Card.HeaderTitle>
                        <Typography.H5>{i18n.t('Home.vision')}</Typography.H5>
                      </Card.HeaderTitle>
                    </Card.Header>
                    <Card.Content>
                      <Typography.Text>{companyVision.Descripcion}</Typography.Text>
                    </Card.Content>
                  </Card.Paper>
                </GridItem>

                {/* Valores */}
                <GridItem item sm={12} xs={12}>
                  <Card.Paper height={200}>
                    <Card.Header>
                      <Card.HeaderTitle>
                        <Typography.H5>{i18n.t('Home.values')}</Typography.H5>
                      </Card.HeaderTitle>
                    </Card.Header>
                    <Card.Content>
                      {companyValues.map((value, index) => (
                        <BoxItem key={index}>
                          <BoxIcon>●</BoxIcon>
                          <Typography.Text>{value.Descripcion}</Typography.Text>
                        </BoxItem>
                      ))}
                    </Card.Content>
                  </Card.Paper>
                </GridItem>
              </MUI.Grid>
            )}

            {/* Objetivos */}
            {(companyVision.length !== 0 || companyValues.length !== 0 || companyGoals.length !== 0) && (
              <GridItem item sm={6} xs={12}>
                <Card.Paper height={432}>
                  <Card.Header>
                    <Card.HeaderTitle>
                      {/* Validación KPMG */}
                      <Typography.H5>{companyId !== 93 ? i18n.t('Home.goals') : i18n.t('Home.attributes')}</Typography.H5>
                    </Card.HeaderTitle>
                  </Card.Header>
                  <Card.Content>
                    {companyGoals.map((goal, index) => (
                      <BoxItem key={index}>
                        <BoxIcon>●</BoxIcon>
                        <Typography.Text>{goal.Descripcion}</Typography.Text>
                      </BoxItem>
                    ))}
                  </Card.Content>
                </Card.Paper>
              </GridItem>
            )}

            {/* Carousel de Fotos */}
            <GridItem item md={6} sm={12} xs={12}>
              <Carousel items={companyImages} />
            </GridItem>

            {/* Avisos */}
            <GridItem item md={6} sm={12} xs={12}>
              <Card.Paper height={432}>
                <News />
              </Card.Paper>
            </GridItem>

            <MUI.Grid container item xs={12}>
              {/* Colaboradores */}
              {showGraphEmployees && (
                <GridItem item md={4} sm={6} xs={12}>
                  <Card.Paper height={280}>
                    <EmployeesGraph
                      man={employeesMan}
                      woman={employeesWoman}
                    />
                  </Card.Paper>
                </GridItem>
              )}

              {/* Cumpleaños */}
              {showBirthdaysMonth && (
                <GridItem item md={4} sm={6} xs={12}>
                  <Card.Paper height={280}>
                    <Birthdays
                      birthdays={birthdaysInfo}
                      onOpen={() => this.openDialog('birthdays')}
                    />
                  </Card.Paper>
                </GridItem>
              )}

              {/* Aniversarios Laborales */}
              {showAnniversariesMonth && (
                <GridItem item md={4} sm={6} xs={12}>
                  <Card.Paper height={280}>
                    <WorkAnniversaries
                      anniversaries={workAnniversariesInfo}
                      onOpen={() => this.openDialog('workAnniversaries')}
                    />
                  </Card.Paper>
                </GridItem>
              )}
            </MUI.Grid>
          </MUI.Grid>
        </Layout.Content>

        {/* Modal de todos los cumpleaños */}
        {birthdaysDialog ? (
          <BirthdaysDialog
            birthdays={birthdaysInfo}
            open={birthdaysDialog}
            onClose={() => this.closeDialog('birthdays')}
          />
        ) : null}

        {/* Modal de todos los aniversarios laborales */}
        {workAnniversariesDialog ? (
          <WorkAnniversariesDialog
            anniversaries={workAnniversariesInfo}
            open={workAnniversariesDialog}
            onClose={() => this.closeDialog('workAnniversaries')}
          />
        ) : null}
      </LoadingWrapper>
    );
  }
}

// *************************************
// STYLED COMPONENTS                               
// *************************************

const GridItem = styled(MUI.Grid)`
  padding: 12px;
`;

const CompanyLogoImg = styled.div`
  /*width: 100%;*/
  height: 100%;
  background-image: url(${(props) => props.url});
  background-size: cover;
  background-position: center;
  border-radius: 6px;
`;

const BoxItem = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
`;

const BoxIcon = styled.div`
  margin: 8px;
  /*width: 20px;*/
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Home;